<template>
  <v-container>
    <v-card color="">
      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold">Multifirma</h2>
        <v-spacer></v-spacer>
        <v-btn color="#0A4A79" dark to="/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
      </v-card-title>
      <!-- <v-divider inset></v-divider> -->
      <v-card-text>
        <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col align="center">
               <h3>BAJO PROTESTA DE DECIR VERDAD, ADJUNTO LOS SIGUIENTES DOCUMENTOS</h3>
            </v-col>
          </v-row><br>

          <!-- <v-container> -->
          <v-card>
            <v-row class="mt-n1 ml-5">
              <v-col cols="12">
                <p class="font-weight-black" align="">Firmar Documento</p>
              </v-col>
            </v-row>

            <v-row class="mt-n5">
              <v-col cols="12"  align="center">
                <span class="font-weight-bold">Subir el escrito de la promoción</span>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-n5 mr-9">
              <v-col cols="12" align="center">
                <v-file-input
                  v-model="file_promocion"
                  color="blue darken-2"
                  label="Seleccionar la promoción"
                  prepend-icon="mdi-paperclip"
                  multiple
                  outlined
                  dense
                  show-size
                  accept="application/pdf, .doc, .docx"
                  truncate-length="50"
                  :rules="fileRules"
                  @change="SelccionarArchivo($event)"
                  :disabled="archivo.encode != ''"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-row class="mt-n6">
                  <v-col cols="12">
                    <p class="font-weight-black" align="center">Firma Firel</p>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-7">
                  <v-col  md="10" align="">
                    <v-file-input
                      v-model="file_firel"
                      color="blue darken-2"
                      label="Seleccionar la firel"
                      prepend-icon="mdi-certificate"
                      outlined
                      dense
                      multiple
                      show-size
                      accept=".pfx"
                      @change="SeleccionarPfx($event)"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-7">
                  <v-col cols="10">
                    <v-text-field outlined dense
                      v-model="password"
                      label="Contraseña"
                      type="text"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      truncate-length="50"
                      :disabled="archivo.encode != ''"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      @click="AgregarFirmante()"
                      color="primary">AGREGAR
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-15">
                  <v-col cols="2">
                    <v-btn
                      :disabled="!activarBtnSign"
                      @click="firmar()"
                      color="primary">FIRMAR
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row>
                <v-col v-if="archivo.file_name" class="ml-6">
                  <ul>
                    <li>
                      <span><b>Promoción Firmada:</b>
                        {{ archivo.file_name }}
                        <v-icon
                         color="green"
                        >mdi-check
                        </v-icon>&nbsp;
                        <v-btn
                          x-small
                          @click="saveTextAsFile()"
                          color="primary">Ver Evidencia
                        </v-btn>&nbsp;
                      </span>
                    </li>
                  </ul>
                </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row class="ml-7">
                  <v-col v-if="Keys" class="ml-6">
                    <b>Firmas Agregadas:</b><br>
                    <ul v-for="(value, key, index) in Keys">
                      <li v-if="value.CertPEM">
                        {{ value.FileName }}
                        <v-icon
                          color="red"
                          @click="removeItem(value)"
                         >mdi-close
                        </v-icon>&nbsp;
                       <br>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </v-card><br>

          <!-- <v-row>
            <v-col cols="12" align="right">
              <v-btn
                tile
                color="success"
                :loading="loading"
                :disabled="!valid"
                @click="validate"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Enviar Promoción
              </v-btn>
            </v-col>
          </v-row> -->

        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

  import { handleUploadFile, handleUpload, _filesToSign, _Keys, AddSigner, Sign, RemoveFile, PKCS7creado, extFileUpload} from '@/services/multifirma';
  import { CertificateRequest } from '@/services/clasesFirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  export default {
    data(){
      return {
        // tipo_firma:"Firel",
        pkcs7:'',
        dialogPdf: false,
        activarBoton: false,
        activarBtnSign: false,
        // filePFXselct: false,
        // fileKEYselct: false,
        // message:'',
        // messageeFirma:'',
        Keys: [],
        extArchivoCargado:'',
        file_firel: [],
        password:'',
        showpass: false,
        loading: false,
        loadingFirma: false,
        valid: true,
        file_promocion:[],
        files:[],
        // documentos:[],
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:'',
          size:''
        },
        creaevidencia:true,
        sign:true,
        user:'',
        // password:'',
        fileRules: [
          files => !files || !files.some(file => file.size > 20971520) || 'El documento no debe exceder de 20MB'
          // v => !v || 'El Campo es Requerido',
        ],
      }
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "roleUser"
      ]),
    },
    watch: {

    },
    mounted() {

    },
    methods:{
      //Metodos Firel
      SelccionarArchivo(file) {
        // console.log(file);
        handleUploadFile(file).then((isValidFile) => {
            if (isValidFile) {
                console.log('Archivo cargado');
                // console.log(_filesToSign[0].HexFile);
                // this.activarFileSign = false;
                // this.activarFilePFX = true;
                this.extArchivoCargado=extFileUpload;
            }
        });
      },
      SeleccionarPfx(filePFX) {
        handleUpload(filePFX).then((isValidFile) => {
            if (isValidFile) {
                console.log('Archivo PFX cargado');
                console.log(_Keys);
                // this.activarIptkeyp = true;
                // this.archivoCargado = true;
            }
        });
      },
      AgregarFirmante() {
          if (this.password) {
              AddSigner(this.password);
              this.activarBtnSign = true;
              this.password = "";
              this.file_firel = [];
              this.Keys = _Keys;
              console.log('AddSigner',_Keys);
              // this.archivoCargado = false;
          }
          else {
              alert("Ingrese su contraseña");
          }
      },
      firmar() {
          Sign().then((isCreatePKCS7) => {
              if (isCreatePKCS7) {
                  var fecha = new Date();
                  this.pkcs7 = PKCS7creado;
                  this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                  this.creaEvidencia(this.pkcs7);
                  // this.saveTextAsFile(this.pkcs7);
                  // this.activarBtnAddSign = false;
              }
          });
      },
      creaEvidencia(pkcs7)
      {
          Swal.fire({
            title: 'Estableciendo comunicación',
            html: 'Generando Evidencia Criptográfica ...',
            // timer: 5000,
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            },
          })
        this.creaevidencia=true;
        // this.loadingFirma = true;
        // let archivos = this.pkcs7.nativeElement.files;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest }).then(response => {
             Swal.close();
             console.log(response.data);
             // this.loadingFirma = false;
             // this.loadingeFirma = false;
             Swal.fire({
               icon: 'success',
               title: 'Promoción Firmada con Éxito',
               confirmButtonText: "Aceptar",
               timer: 1500,
             })
             this.archivo.encode = response.data.data.PdfBase64;
             var fecha = new Date();
             this.archivo.file_name = "evidencia_" + fecha.valueOf();
             // this.sign = true;
             this.file_firel = [];
             this.file_promocion = [];
             this.password = '';
             // this.activarBoton = false;
           })
           .catch(err => {
             console.log(err);
             // this.loadingFirma = false;
           });
        } else {
          this.creaevidencia=false;
        }
      },
      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      removeItem(item){
        RemoveFile(item)
        // this.documentos.splice(this.documentos.indexOf(item), 1);
      },
    }
  }
</script>
